import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=435b9e96"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports